import React from 'react';
import styled from 'styled-components';
import { Asset } from '../../../types/asset';
import { Document } from '@contentful/rich-text-types';
import { RichText } from '../../richText';

interface CaseStudyHeroProps {
  title: string;
  heroContent: Document;
  backgroundImage?: Asset;
}

const ImageHolder = styled.div<{ background: string }>(({ background }) => `
    background-image: url(${background});
    background-size: cover;
    background-repeat: no-repeat;
    max-width: 100%;
    background-position: center center;
    height: 50vh;
    max-height: 300px;

    @media (min-width: 640px) {
      height: 50vh;
      max-height: 600px;
  }
`);

export const CaseStudyHero: React.FC<CaseStudyHeroProps> = ({
  title,
  heroContent,
  backgroundImage,
}) => {
  return (
    <div className="w-full pt-20 cs-block-natural">
      {backgroundImage &&
        <ImageHolder background={backgroundImage.url} />
      }
      <div className="w-full mx-auto lg:flex md:max-w-6xl lg:pt-16 lg:mb-32">

        <div className="p-8 mb-12 lg:w-1/2">
          <p className="mb-4 text-sm">CASE STUDY</p>
          <h1 className="text-4xl font-semibold">{title}</h1>
        </div>
        <div className="p-8 lg:w-1/2">
          <RichText content={heroContent} />
        </div>
      </div>

    </div>
  );
};
